var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtInConstruction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.30387 5.19361H0.750698C0.336099 5.19361 0 5.52971 0 5.94431V8.05524C0 8.46984 0.336099 8.80594 0.750698 8.80594H6.30387C6.71847 8.80594 7.05457 8.46984 7.05457 8.05524V5.94431C7.05457 5.52971 6.71847 5.19361 6.30387 5.19361Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2492 5.19365H8.69601C8.28141 5.19365 7.94531 5.52974 7.94531 5.94434V8.05528C7.94531 8.46988 8.28141 8.80597 8.69601 8.80597H14.2492C14.6638 8.80597 14.9999 8.46988 14.9999 8.05528V5.94434C14.9999 5.52974 14.6638 5.19365 14.2492 5.19365Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2765 0.677948H4.72335C4.30876 0.677948 3.97266 1.01405 3.97266 1.42865V3.53958C3.97266 3.95418 4.30876 4.29028 4.72335 4.29028H10.2765C10.6911 4.29028 11.0272 3.95418 11.0272 3.53958V1.42865C11.0272 1.01405 10.6911 0.677948 10.2765 0.677948Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2765 9.70974H4.72335C4.30876 9.70974 3.97266 10.0458 3.97266 10.4604V12.5714C3.97266 12.986 4.30876 13.3221 4.72335 13.3221H10.2765C10.6911 13.3221 11.0272 12.986 11.0272 12.5714V10.4604C11.0272 10.0458 10.6911 9.70974 10.2765 9.70974Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtInConstruction);
export default __webpack_public_path__ + "static/media/bt-in-construction.b5caf929ab703ab955067de70898c131.svg";
export { ForwardRef as ReactComponent };